export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-warm-white min-h-[85vh] flex items-center pt-24 pb-20">
      <div className="w-full px-20">
        <div className="flex items-center gap-16">
          {/* Left Column - Content */}
          <div className="w-[55%] pt-12">
            {/* Headline */}
            <h1 className="font-serif text-[56px] leading-[1.15] text-charcoal max-w-[520px] mb-20">
              Professional English that matches your credentials—without losing who you are.
            </h1>

            {/* Subheadline */}
            <p className="font-sans text-xl leading-relaxed text-warm-gray max-w-[480px] ml-6 mb-16">
              Edbilities helps fluent non-native English speakers build a more natural, credible professional English accent—along with the rhythm, vocabulary, and depth that professional English requires—so clients, colleagues, and decision-makers hear your expertise, not your accent.
            </p>

            {/* CTA Buttons */}
            <div className="flex items-center gap-5">
              <button
                onClick={() => scrollToSection('cta')}
                className="bg-teal text-white px-10 py-4 rounded-xl text-lg font-medium font-sans shadow-lg shadow-teal/15 hover:bg-teal/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Start Building Your Professional English
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="bg-transparent border-2 border-gray-300 text-charcoal px-10 py-4 rounded-xl text-lg font-medium font-sans hover:bg-teal/5 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                See How It Works
              </button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="w-[45%] relative">
            <div className="relative rounded-l-2xl overflow-hidden" style={{ marginRight: '-80px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/c96f2bf1238dfe2462a8d7c65305b0da.jpg"
                alt="Professional business conversation"
                className="w-full h-auto object-cover object-top"
                style={{ minHeight: '600px' }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/5 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
